import React, { useState } from 'react';

import { useQuery } from 'react-apollo';

import Select from 'Components-redesign/Fields/Select';
import useModal from 'Components-redesign/Modal/useModal';
import { useI18n, useSelector } from 'Hooks';
import CreateCategory from 'Scenes-redesign/PIM/Components/CreateContent/Category';
import {
  getActivatedFeatures,
  getCategoriesList,
  getCoursetypeList,
} from 'Scenes-redesign/PIM/utils';

import { COMPANY_QUERY } from './queries';

export interface Props {
  id: string;
  placeholder: string;
  list: any;
  formData: any;
  handleChange: (name, value) => void;
}

const CategorySelect = ({ id, placeholder, list, formData, handleChange }: Props) => {
  const companyId = useSelector(({ company }) => company);
  const [selectList, setSelectList] = useState(list);
  const { data } = useQuery(COMPANY_QUERY, { variables: { companyId } });
  const { isShowing, toggle, hide } = useModal();
  const { t } = useI18n();

  const activatedFeatures = getActivatedFeatures(data?.company);
  const categories = data ? getCategoriesList(data?.company?.categories) : [];
  const courseTypes = getCoursetypeList(data?.company.courseTypes);

  const onSuccess = (value) => {
    setSelectList((prev) => [...prev, value]);
    handleChange(id, value);
    hide();
  };

  return (
    <div>
      <Select
        name={id}
        placeholder={placeholder ?? t('General.Choose')}
        selected={{ id: formData.value?.id ?? formData.value } ?? ''}
        handleChange={(name, value) => handleChange(name, value)}
        list={selectList}
        addButton={{
          text: t('PIM.NewCategory'),
          handleClick: toggle,
        }}
      />
      {isShowing && (
        <CreateCategory
          categories={categories ?? []}
          coursetypes={courseTypes}
          closeModal={hide}
          handleFormSuccess={(val) => onSuccess(val)}
          activatedFeatures={activatedFeatures}
        />
      )}
    </div>
  );
};

export default CategorySelect;
